export const waitTimesData = [
  { state: 'NSW', emergency: 15, elective: 36, ambulance: 8 },
  { state: 'VIC', emergency: 12, elective: 42, ambulance: 6 },
  { state: 'SA', emergency: 18, elective: 48, ambulance: 10 },
  { state: 'WA', emergency: 20, elective: 30, ambulance: 12 },
  { state: 'QLD', emergency: 14, elective: 24, ambulance: 7 },
  { state: 'National', emergency: 16, elective: 36, ambulance: 9 }
];

export const issueCategories = [
  { name: 'Wait Times', count: 47, severity: 'Critical' },
  { name: 'Emergency Dept', count: 34, severity: 'Critical' },
  { name: 'Staffing', count: 28, severity: 'Critical' },
  { name: 'Nurses', count: 25, severity: 'Critical' },
  { name: 'Private System', count: 22, severity: 'High' },
  { name: 'Public Hospital', count: 20, severity: 'High' },
  { name: 'Ambulance', count: 18, severity: 'High' },
  { name: 'Medicare', count: 16, severity: 'Medium' },
  { name: 'Doctors', count: 15, severity: 'Medium' },
  { name: 'Beds', count: 14, severity: 'High' }
];

export const geographicData = [
  { state: 'NSW', incidents: 15, severity: 'Critical', issues: 'ED wait times, Northern Beaches Hospital' },
  { state: 'VIC', incidents: 12, severity: 'Critical', issues: 'Ambulance unavailability, ED overcrowding' },
  { state: 'SA', incidents: 8, severity: 'High', issues: 'Extreme wait times, Lyell McEwin Hospital' },
  { state: 'WA', incidents: 7, severity: 'Critical', issues: 'Worst urgent ED wait times nationally' },
  { state: 'QLD', incidents: 4, severity: 'Medium', issues: 'System-wide issues, specialist access' },
  { state: 'National', incidents: 18, severity: 'High', issues: 'Medicare inadequacy, private healthcare' }
];

export const trendingThemes = [
  { theme: 'Privatization Concerns', evidence: 15, sentiment: 'Highly Negative' },
  { theme: 'System Breakdown', evidence: 25, sentiment: 'Extremely Negative' },
  { theme: 'Staff Exodus', evidence: 10, sentiment: 'Negative' },
  { theme: 'Regional Inequality', evidence: 8, sentiment: 'Negative' },
  { theme: 'Government Inaction', evidence: 12, sentiment: 'Very Negative' },
  { theme: 'Corporate Accountability', evidence: 6, sentiment: 'Negative' }
];

export const severityData = [
  { category: 'Critical Issues', count: 16, percentage: 45 },
  { category: 'High Issues', count: 10, percentage: 28 },
  { category: 'Medium Issues', count: 7, percentage: 20 },
  { category: 'Low Issues', count: 3, percentage: 7 }
];

export const youtubeSources = [
  { channel: '60 Minutes Australia', videos: 1, commentStatus: 'Closed', category: 'Medical Malpractice' },
  { channel: 'ABC Four Corners', videos: 2, commentStatus: 'Mixed', category: 'Medical Industry' },
  { channel: '9 News Australia', videos: 1, commentStatus: 'Closed', category: 'Medical Crime' },
  { channel: 'The Australia Institute', videos: 1, commentStatus: 'Open', category: 'Healthcare Policy' },
  { channel: 'Dr. Glaucomflecken', videos: 1, commentStatus: 'Open', category: 'Healthcare Satire' }
];

export const redditSources = [
  { subreddit: 'r/AskAnAustralian', posts: 5, category: 'General Discussion' },
  { subreddit: 'r/australia', posts: 4, category: 'National Issues' },
  { subreddit: 'r/sydney', posts: 3, category: 'Regional NSW' },
  { subreddit: 'r/melbourne', posts: 2, category: 'Regional VIC' },
  { subreddit: 'r/adelaide', posts: 2, category: 'Regional SA' },
  { subreddit: 'r/perth', posts: 1, category: 'Regional WA' },
  { subreddit: 'r/ausjdocs', posts: 3, category: 'Medical Professionals' }
];

export const topKeywords = [
  { keyword: 'wait times', frequency: 47, context: 'Emergency departments and elective procedures' },
  { keyword: 'emergency department', frequency: 34, context: 'Primary point of healthcare crisis' },
  { keyword: 'staffing', frequency: 28, context: 'Core system failure' },
  { keyword: 'nurses', frequency: 25, context: 'Frontline workforce issues' },
  { keyword: 'private', frequency: 22, context: 'Healthcare system structure' },
  { keyword: 'public hospital', frequency: 20, context: 'Government healthcare provision' },
  { keyword: 'ambulance', frequency: 18, context: 'Emergency response failures' },
  { keyword: 'Medicare', frequency: 16, context: 'Healthcare funding system' },
  { keyword: 'doctors', frequency: 15, context: 'Healthcare workforce' },
  { keyword: 'beds', frequency: 14, context: 'Infrastructure capacity' }
];